export const config = {
  formId: 'featured_app',
  formTitle: 'Featured App',
  formValueType: 'Object',
  formNote:
    'By selecting below options, you can set whether the app is Featured or not',
  tabs: [
    {
      id: 'featured_app',
      label: 'Featured App',
      contents: [
        {
          id: 'featured_app_contents',
          fields: [
            {
              name: 'featured_app',
              label: 'Featured app options',
              disabled: false,
              type: 'adminControlFeaturedApp',
              style: 'payment-options-style',
              gridStyle: 'layoutcell'
            }
          ]
        }
      ]
    }
  ],
  formFields: {
    featured_app: {
      isFeatured: ''
    }
  },
  activeTabId: 'featured_app'
};
